// ==================== NOTIFICATIONS SERVICE ====================
// Extracted from database.js - contains all notifications functionality

import { 
  collection, 
  doc, 
  getDocs, 
  addDoc, 
  updateDoc, 
  query, 
  where, 
  serverTimestamp 
} from 'firebase/firestore';
import { db } from '../../utils/database/firebase-config';

export const notificationsService = {
  async createRoleNotification(companyId, roles, notificationData) {
    const notificationsRef = collection(db, 'notifications');
    const docRef = await addDoc(notificationsRef, { 
      ...notificationData, 
      companyId, 
      roles, 
      createdAt: serverTimestamp() 
    });
    return docRef.id;
  },
  
  async getUserNotifications(userId, companyId) {
    const notificationsRef = collection(db, 'notifications');
    const q = query(notificationsRef, 
      where('userId', '==', userId), 
      where('companyId', '==', companyId)
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  },
  
  async markAsRead(notificationId) {
    const notificationRef = doc(db, 'notifications', notificationId);
    await updateDoc(notificationRef, { read: true });
    return true;
  }
}; 